import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Award, MessageSquare, Brain } from 'lucide-react';
const features = [{
  icon: ShieldCheck,
  title: '严格审核机制',
  enTitle: 'Strict Verification',
  desc: '每一位技师都经过身份认证与技能考核，确保服务安全可靠。'
}, {
  icon: Award,
  title: '专业资质认证',
  enTitle: 'Professional Certification',
  desc: '平台技师均持有相关专业证书，拥有丰富的从业经验。'
}, {
  icon: MessageSquare,
  title: '用户真实评价',
  enTitle: 'Authentic Reviews',
  desc: '100%真实用户点评，拒绝刷单，为您提供最客观的参考。'
}, {
  icon: Brain,
  title: '智能匹配推荐',
  enTitle: 'Smart Matching',
  desc: '根据您的需求与偏好，智能算法为您推荐最合适的技师。'
}];
export function WhyChooseUs() {
  return <section id="about" className="py-24 bg-[#FDF8F0] relative overflow-hidden" data-id="element-184">
      {/* Decorative Background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-185">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#C9A96E]/10 rounded-full blur-3xl" data-id="element-186"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-[#2D5A3D]/5 rounded-full blur-3xl" data-id="element-187"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-188">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-189">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-190">
            <span className="text-[#C9A96E] font-medium tracking-widest uppercase text-sm" data-id="element-191">
              Why Choose Us
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A3D] mt-2 mb-6" data-id="element-192">
              为什么选择 <br data-id="element-193" />
              新加坡爽吧 Shiok8?
            </h2>
            <p className="text-[#666] text-lg mb-8 leading-relaxed" data-id="element-194">
              作为新加坡历史最悠久的按摩推荐平台，我们深知信任的重要性。20年来，我们始终坚持高标准，只为您提供最放心的服务。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-195">
              {features.map((feature, index) => <div key={index} className="flex items-start space-x-4" data-id="element-196">
                  <div className="flex-shrink-0" data-id="element-197">
                    <div className="w-10 h-10 rounded-lg bg-[#2D5A3D]/10 flex items-center justify-center text-[#2D5A3D]" data-id="element-198">
                      <feature.icon size={20} data-id="element-199" />
                    </div>
                  </div>
                  <div data-id="element-200">
                    <h4 className="text-lg font-bold text-[#1A1A1A]" data-id="element-201">
                      {feature.title}
                    </h4>
                    <p className="text-xs text-[#C9A96E] uppercase tracking-wide mb-2" data-id="element-202">
                      {feature.enTitle}
                    </p>
                    <p className="text-sm text-[#666]" data-id="element-203">{feature.desc}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-204">
            <div className="bg-white p-2 rounded-2xl shadow-xl rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-205">
              <div className="aspect-[4/3] bg-[#2D5A3D] rounded-xl overflow-hidden relative" data-id="element-206">
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/80 to-transparent flex items-end p-8" data-id="element-207">
                  <div className="text-white" data-id="element-208">
                    <p className="font-serif text-2xl italic" data-id="element-209">
                      "Relaxation is the stepping stone to tranquility."
                    </p>
                  </div>
                </div>
                {/* Decorative pattern */}
                <div className="absolute top-0 right-0 p-8 opacity-20" data-id="element-210">
                  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-211">
                    <circle cx="50" cy="50" r="48" stroke="white" strokeWidth="2" data-id="element-212" />
                    <circle cx="50" cy="50" r="38" stroke="white" strokeWidth="2" data-id="element-213" />
                    <circle cx="50" cy="50" r="28" stroke="white" strokeWidth="2" data-id="element-214" />
                  </svg>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}